<template>
  <div class="align-items-stretch d-flex flex-column flex-nowrap h-100 w-100">
    <PerformanceOverviewTable v-if="selectedColumns !== null"
                              ref="table"
                              :selected-columns="selectedColumns"
                              :initial-page-size="initialPageSize"
                              :portlet-u-id="portletUId"></PerformanceOverviewTable>
    <SettingsModal v-if="columnConfiguration"
                   ref="settings"
                   :portlet-u-id="portletUId"
                   :column-config="columnConfiguration"
                   @change="onSettingsChange"></SettingsModal>
  </div>
</template>

<script>
  import PerformanceOverviewTable from './components/PerformanceOverviewTable.vue';
  import PerformanceOverviewService from './PerformanceOverviewService';
  import PortletEvent from '~/zf/frontend/vcom/events/PortletEvent';
  import SettingsModal from './components/SettingsModal.vue';
  import WindowProvider from '~/zf/frontend/common/window/WindowProvider';
  import EventService from '~/zf/frontend/common/event/EventService';

  export default {
    name: 'PerformanceOverview',
    compatConfig: {
      MODE: 3,
      INSTANCE_EVENT_EMITTER: true,
    },
    components: {
      PerformanceOverviewTable,
      SettingsModal,
    },
    props: {
      portletUId: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        columnConfiguration: null,
        selectedColumns: null,
        initialPageSize: null,
      };
    },
    computed: {
      portletId() {
        return `portlet_${this.portletUId}`;
      },
    },
    async created() {
      EventService.addListener(PortletEvent.CONFIG_CLICKED, {
        target: WindowProvider.document.getElementById(this.portletId),
        callback: this.openSettingsModal,
      });
      this.columnConfiguration = await PerformanceOverviewService.getColumnConfiguration(this.portletUId);

      const { columnSettings, pageSize } = this.columnConfiguration;
      this.initialPageSize = pageSize;
      this.selectedColumns = columnSettings.columns;
    },
    methods: {
      onSettingsChange(value) {
        this.selectedColumns = value;
        this.$refs.table.updateColumns(value);
      },
      openSettingsModal() {
        this.$refs.settings.show();
      },
    },
  };
</script>
